module.exports = __webpack_public_path__ + "assets/img/404.6b742713.jpg";